import { ActionTask, ActionItem } from '../graphics/ActionMap';
import {changeShapeColor, StrokeStyle} from '../graphics/cjs-lib';
import {Animation, Handler, TweenCommand, TweenItem} from './Animation';
import { makeColorGradient } from '../graphics/Color';

import { Component } from 'react';
import { connect } from 'react-redux';
import {
  setActionMap
} from '../actions';


// function isNumber(x) {
//   return isNaN(Number(x));
// }

function isPositiveNumber(x) {
  return !isNaN(Number(x)) && x > 0;
}

export function getHeapPositions({n, dx, dy, width, height}) {

  /*
   *    n    height = Math.floor(Math.log2(n)) + 1
   *    0       0
   *    1       1
   *    2       2
   *    3       2
   *    4-7     3
   *    8-15    4
   *    16-31   5
   */
  if (!isPositiveNumber(n)) {
    throw new Error('createHeapPositions: n must be a positive number');
  }
  if (!isPositiveNumber(dx)) {
    throw new Error('createHeapPositions: dx must be a positive number');
  }
  if (!isPositiveNumber(dy)) {
    throw new Error('createHeapPositions: dy must be a positive number');
  }
  if (!isPositiveNumber(width)) {
    throw new Error('createHeapPositions: width must be a positive number');
  }
  if (!isPositiveNumber(height)) {
    throw new Error('createHeapPositions: height must be a positive number');
  }
  const positions = [];
  if (n === 1) {
    positions.push([width / 2, height / 2]);
    return positions;
  }
  const heapHeight = Math.floor(Math.log2(n)) + 1;
  const minDx = height / heapHeight;
  const minDy = width / heapHeight;
  dx = Math.min(dx, minDx);
  dy = Math.min(dy, minDy);
  let x;
  let y = (height - dy * heapHeight) / 2;
  let columns;
  let xc = width / 2;
  let i = 0;
  let dxRow;
  let heapWidth = (2 ** (heapHeight - 1)) * dx;
  for (let row = 0; row < heapHeight; row++) {
    y += dy;
    columns = 2 ** row;
    dxRow = heapWidth / columns;
    x = xc - (columns - 1) * dxRow / 2;
    for (let column = 0; column < columns; column++) {
      positions.push([x, y]);
      i += 1;
      if (i === n) {
        return positions;
      }
      x += dxRow;
    }
  }
  return positions;
}

export function getHeapLines({ positions }) {
  let parent;
  let line;
  const lines = [];
  for (let child = 1; child < positions.length; child++) {
    parent = Math.floor((child - 1) / 2);
    line = {
      x0: positions[parent][0],
      y0: positions[parent][1],
      x1: positions[child][0],
      y1: positions[child][1]
    };
    lines.push(line);
  }
  return lines;
}

export function createHeapValueArray(
  { strokeStyle, width, height, color, n, dx, dy, parentId }
){
  const positions = getHeapPositions({n, dx, dy, width, height});
  const lineArray = getHeapLines({ positions });
  const valueArray = lineArray.map(line => {
    return Object.assign(line, { parentId, color, strokeStyle });
  });
  return { positions, heapValueArray: valueArray };
}

export function heapAnimation ({ actionMap, parentId, n, width = 600, height = 600, dx = 50, dy = 50 }) {

  let bounds;
  let attrs;
  let type;
  let id;
  let actionId;
  let value;
  let parameters;
  let actionTask;
  let actionItem;
  let actionType;

  actionType = 'ADD_DISPLAY_OBJECT';

  bounds = { x: 0, y: 0, width, height};
  attrs = { x: 0, y: 0, color: '#ffe', alpha: 1, hitArea: false};
  type = 'SHAPE_MOVIE_CLIP';
  parentId = 0;
  id = Animation.getNextId();
  actionId = Animation.getNextActionId();
  value = {bounds, attrs, name: 'Heap-Container'};
  parameters = { parentId, id, type, value, actionId };

  actionTask = new ActionTask({ actionType, parameters });
  actionItem = new ActionItem({ actionId, actionTask });
  actionMap.set(actionId, actionItem);

  const strokeStyle = new StrokeStyle({ cap: 'round', joints: 'round' });
  const { positions, heapValueArray } = createHeapValueArray({ parentId, strokeStyle, width, height, n, dx, dy });

  type = 'LINE';
  parentId = id;
  const lines = [];
  heapValueArray.forEach((value, i) => {

    id = Animation.getNextId();
    actionId = Animation.getNextActionId();
    value = Object.assign({}, value, { name: `line-${i}`});
    parameters = { parentId, id, type, value, actionId };
    lines.push(parameters);

    actionTask = new ActionTask({ actionType, parameters });
    actionItem = new ActionItem({ actionId, actionTask });
    actionMap.set(actionId, actionItem);

  });

  const shapes = createHeapShapes({ actionMap, positions, parentId, dx });
  return {parentId, lines, shapes};
}

function createHeapShapes({ actionMap, positions, parentId, dx }) {

  const colors = makeColorGradient({ len: positions.length });
  console.log(colors);
  let actionType;
  let bounds;
  let attrs;
  let type;
  let id;
  let actionId;
  let value;
  let parameters;
  let actionTask;
  let actionItem;
  let width = dx / 2;
  let height = dx / 2;
  bounds = { x: 0, y: 0, width, height};
  const shapes = [];
  let score;
  positions.forEach((p, i) => {
    actionType = 'ADD_DISPLAY_OBJECT';
    score = positions.length - i;

    type = 'SHAPE_MOVIE_CLIP';
    id = Animation.getNextId();
    attrs = { x: p[0] - width / 2, y: p[1] - height / 2, color: colors[i].hex, alpha: 1, score, id};
    actionId = Animation.getNextActionId();
    value = {bounds, attrs, name: `Heap-Item ${id}`};
    parameters = { parentId, id, type, value, actionId };
    shapes.push(parameters);

    actionTask = new ActionTask({ actionType, parameters });
    actionItem = new ActionItem({ actionId, actionTask });
    actionMap.set(actionId, actionItem);

  });
  return shapes;

}

/**
 * This is a maxHeap.
 *
 * If the value of a node increases, call swim.
 * If the value of a node decreases, call sink.
 */
export class HeapController extends Component {

  constructor(props) {
    super(props);
    this.initialized = false;
    this.lines = null;
    this.shapes = null;
    this.tweenActionId = null;
  }

  componentDidUpdate() {
    if (this.props.actionMap && !this.initialized) {
      this.setupHeap();
    }
    if (this.tweenActionId) {
      /**
       * @type {ActionMap} actionMap
       * @type {Tree} tree
       */
      const {actionMap, tree} = this.props;
      if (actionMap.isCompleted({ actionId: this.tweenActionId })) {
        this.tweenActionId = null;
        const node = tree.get(this.parentId);
        if (node && node.displayObject) {
          node.displayObject.enableHitArea();
        }
      }
    }
  }

  componentDidMount() {
    if (this.props.actionMap && !this.initialized) {
      this.setupHeap();
    }
  }

  setupHeap() {
    this.initialized = true;
    this.heap = new Heap({type: 'max', key: 'score'});
    const { actionMap, dispatch } = this.props;
    const newActionMap = actionMap.clone();
    const { parentId, lines, shapes } = heapAnimation({ actionMap: newActionMap, n: 15 });
    this.dt = 1000;
    this.parentId = parentId;
    shapes.forEach(shape => {
      this.heap.insert(shape.value.attrs);
    });
    console.log('heap', this.heap);
    this.lines = lines;
    this.shapes = shapes;
    this.addHandlers({newActionMap});
    console.log('setupHeap actionMap', newActionMap);
    dispatch(setActionMap({ actionMap: newActionMap }));
  }

  addHandlers({newActionMap}) {
    // const { tree, actionMap, dispatch } = this.props;
    let cb = () => {
      const color1 = '#ff0';
      const color2 = '#00f';
      let color = color1;
      return function (evt) {
        console.log('clicked', this);
        const shape = evt.target.children[0];
        color = color === color1 ? color2 : color1;
        changeShapeColor({ shape, color });
        this.value.score = typeof this.value.score === 'number' ? this.value.score : 0;
        this.value.score += 1;
        console.log('handler', this.value);
      };
    };
    let callback = cb();
    const id = this.shapes[0].id;
    const handler = new Handler({ action: 'click', callback, id });
    const actionId = Animation.getNextActionId();
    // dispatch(addHandler({ id, actionId, handler }));
    // const newActionMap = actionMap.clone();

    const actionType = 'ADD_HANDLER';
    const parameters = { id, actionId, handler };
    const actionTask = new ActionTask({ actionType, parameters });
    const actionItem = new ActionItem({ actionId, actionTask });
    newActionMap.set(actionId, actionItem);

    this.shapes.forEach(shape => {
      const id = shape.id;
      const callback = this.createExchangeHandler({id, newActionMap});
      const handler = new Handler({ action: 'click', callback, id });
      const actionId = Animation.getNextActionId();

      const actionType = 'ADD_HANDLER';
      const parameters = { id, actionId, handler };
      const actionTask = new ActionTask({ actionType, parameters });
      const actionItem = new ActionItem({ actionId, actionTask });
      newActionMap.set(actionId, actionItem);
    });

  }

  /*
   * If heap item is not the root, add tweens to exchange with the parent
   */
  createExchangeHandler({id}) {
    let heap = this.heap;
    const dt = this.dt;
    let that = this;
    const actionType = 'START_TWEEN';
    return function(evt) {
      const newActionMap = that.props.actionMap.clone();
      const childIndex = heap.getIndex({id});
      /*
       * root is index 0
       */
      if (childIndex >= 1) {
        const parentIndex = Math.floor((childIndex - 1) / 2);
        const child = heap.getValue({index: childIndex});
        const parent = heap.getValue({index: parentIndex});
        let startActionId;
        let actionId;
        let tweenId;
        if (parent) {
          const parentId = parent.id;
          const tweenCommand1 = new TweenCommand({
            type: 'to',
            value: { x: parent.x, y: parent.y },
            dt
          });
          startActionId = Animation.getNextActionId();
          actionId = Animation.getNextActionId();
          tweenId = Animation.getNextTweenId();
          const tweenItem1 = new TweenItem({ tweenId, id, commands: [tweenCommand1], actionId });
          const parameters1 = {
            tweenItem: tweenItem1,
            startActionId,
            actionId
          };
          const actionTask1 = new ActionTask({ actionType, parameters: parameters1 });
          const actionItem1 = new ActionItem({ actionId, actionTask: actionTask1 });
          newActionMap.set(actionId, actionItem1);

          const tweenCommand2 = new TweenCommand({
            type: 'to',
            value: { x: child.x, y: child.y },
            dt
          });
          startActionId = Animation.getNextActionId();
          actionId = Animation.getNextActionId();
          tweenId = Animation.getNextTweenId();
          const tweenItem2 = new TweenItem({ tweenId, id: parentId, commands: [tweenCommand2], actionId });
          const parameters2 = {
            tweenItem: tweenItem2,
            startActionId,
            actionId
          };
          const actionTask2 = new ActionTask({ actionType, parameters: parameters2 });
          const actionItem2 = new ActionItem({ actionId, actionTask: actionTask2 });
          newActionMap.set(actionId, actionItem2);
          if (that.props.dispatch) {
            that.props.dispatch(setActionMap({ actionMap: newActionMap }));
          }
          that.heap.exchange(parentIndex, childIndex);
          that.enableHitArea();
          that.tweenActionId = actionId;
        }
      }
    };
  }

  /*
   * prevent click handlers from going to the shapes
   */
  enableHitArea() {
    const {tree} = this.props;
    if (tree && this.parentId) {
      const node = tree.get(this.parentId);
      if (node && node.displayObject) {
        node.displayObject.enableHitArea();
      }
    }
  }

  render() {
    return null;
  }

}

class Heap {

  constructor({ type = 'min', key }) {
    if (type === 'max') {
      this.type = 'max';
    } else {
      this.type = 'min';
    }
    this.key = key;
    this.storage = [];
  }

  getIndex({id}) {
    return this.storage.findIndex(item => item.id === id);
  }

  getValue({index}) {
    return this.storage[index];
  }

  compare(parent, child) {
    if (this.type === 'min') {
      return this.storage[parent][this.key] <= this.storage[child][this.key];
    }
    return this.storage[parent][this.key] >= this.storage[child][this.key];
  }

  insert(value) {
    this.storage.push(value);
    this.swim(this.storage.length - 1);
  }

  /*
   * parent of 1 = 0
   * parent of 2 = 0
   * parent of 3 = 1
   * parent of 4 = 1
   * parent of 5 = 2
   * parent of 6 = 2
   */
  swim(child) {
    if (child === 0) {
      return;
    }
    const parent = Math.floor((child - 1) / 2);
    if (!this.compare(parent, child)){
      [this.storage[child], this.storage[parent]] = [this.storage[parent], this.storage[child]];
      this.swim(parent);
    }
  }

  peek() {
    return this.storage[0];
  }

  remove() {
    if (!this.storage.length) {
      return null;
    }
    const root = this.storage[0];
    const tail = this.storage.pop();
    if (this.storage.length) {
      this.storage[0] = tail;
    }
    this.sink(0);
    return root;
  }

  /*
   * parent = 0, children = 1,2
   * parent = 1, children = 3,4
   * parent = 2, children = 5,6
   */
  sink(parent) {
    const left = parent * 2 + 1;
    const right = parent * 2 + 2;
    if (left > this.storage.length -1) {
      return;
    }
    let child = left;
    if (right < this.storage.length) {
      child = this.compare(left, right) ? left : right;
    }
    if (!this.compare(parent, child)) {
      [this.storage[parent], this.storage[child]] = [this.storage[child], this.storage[parent]];
      this.sink(child);
    }
  }

  exchange(index1, index2) {
    // console.log(`exchange: ${index1}, ${index2}`);
    // this.print();
    const item1 = this.storage[index1];
    const item2 = this.storage[index2];
    const x1 = item1.x;
    const y1 = item1.y;
    const x2 = item2.x;
    const y2 = item2.y;
    item1.x = x2;
    item1.y = y2;
    item2.x = x1;
    item2.y = y1;
    [this.storage[index1], this.storage[index2]] = [this.storage[index2], this.storage[index1]];
    // console.log('after exchange');
    // this.print();
  }

  print() {
    this.storage.forEach((v, i) => {
      console.log(`${i}: {id: ${v.id}, x: ${v.x}, y: ${v.y}}`);
    });
  }

}


function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(HeapController);
